// Modal.tsx
import React, { useEffect, useRef } from 'react';
import '../CalendarDarkMode.css';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

export default function Modal({ isOpen, onClose, children }: ModalProps) {
  const overlayRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!isOpen) return;

    const handleEscape = (event: KeyboardEvent) => {
      if (event.key !== 'Escape') return;

      const modalLayers = Array.from(
        document.querySelectorAll<HTMLElement>('[data-calendar-modal-layer="true"]')
      );
      const topmostLayer = modalLayers[modalLayers.length - 1];

      if (topmostLayer === overlayRef.current) {
        onClose();
      }
    };

    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div
      ref={overlayRef}
      data-calendar-modal-layer="true"
      style={{
        position: 'fixed',
        top: 0, left: 0, right: 0, bottom: 0,
        backgroundColor: 'rgba(0,0,0,0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000,
        padding: '16px', // prevent modal from touching screen edges
      }}
    >
        {/* Close Button */}
        {/* <div style={{ textAlign: 'right', padding: '12px 16px 0' }}>
          
        </div> */}

        {/* Scrollable content */}
        <div className="calendar-modal-content rounded-3xl">
          {children}
        </div>
    </div>
  );
}
